<template>
  <div>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="10" :lg="6">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>个人中心</span>
            <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
          </div>
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="旧密码">
              <el-input v-model="form.old_password"></el-input>
            </el-form-item>
            <el-form-item label="新密码">
              <el-input v-model="form.new_password"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSetUserPwd">修改密码</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="14" :lg="12">
        <feishu-authorization-card />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import FeishuAuthorizationCard from './FeishuAuthorizationCard.vue';
import { handleSetUserPwdApi } from "@/api/admin_user.js";
import { removeToken, removeName, removeRoles } from "@/utils/localStorage.js";
export default {
  components: { FeishuAuthorizationCard },
  data() {
    return {
      form: {
        old_password: "",
        new_password: ""
      }
    };
  },
  methods: {
    handleSetUserPwd() {
      handleSetUserPwdApi(this.form)
        .then(response => {
          this.$message({
            message: response.data.message,
            type: "success"
          });
          removeToken();
          removeName();
          removeRoles();
          this.$router.push({ path: "/login" });
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
